import { ProductType } from 'types/enums';

export const getCountedItemKey = (type: ProductType | null) => {
  if (!type) {
    return '';
  }

  const keys = {
    [ProductType.CV_CONTACTS_OPEN]: 'opens',
    [ProductType.VACANCY]: 'placements',
  };

  return keys[type];
};
